import { toAbsoluteSrc } from '../types';
import {
    type MessageSearchModeEnum,
    type Message,
    type MessageCloseActionEnum,
    type MessagePrivacyEnum,
    type MessageTypeEnum,
} from '@clients/ContentApi';

export default class SiteMessage {
    constructor(data: Message) {
        this.id = data.id;
        this.text = data.text || '';
        this.urlPattern = data.urlPattern;
        this.closeAction = data.closeAction;
        this.whiteLabel = data.whiteLabel;
        this.privacy = data.privacy;
        this.mode = data.type;
        this.icon = {
            src: toAbsoluteSrc(data.icon?.url) || '',
            alt: data.icon?.alternativeText || '',
        };
        this.url = data.url;
        this.searchMode = data.searchMode;
    }

    id: string;
    text: string;
    urlPattern?: string;
    closeAction?: MessageCloseActionEnum;
    whiteLabel?: string;
    privacy?: MessagePrivacyEnum;
    mode?: MessageTypeEnum;
    url?: string;
    icon?: {
        src: string;
        alt: string;
    };

    searchMode?: MessageSearchModeEnum;

    toJSON() {
        return { ...this };
    }
}
